export default {
    setDirectorio(state, d) {
        state.directorioMatriz = d;
    },
    setDirectorioObj(state, obj) {
        state.directorioMatrizObj = obj;
    },
}